import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private readonly bannerState = new BehaviorSubject<{ visible: boolean; content: string | null }>({
    visible: false,
    content: null,
  });

  public bannerState$: Observable<{ visible: boolean; content: string | null }> =
    this.bannerState.asObservable();

  updateBanner(visible: boolean, content: string | null): void {
    this.bannerState.next({ visible, content });
  }
}
